<template>
  <f7-page name="Profile" class="profile">
    <f7-navbar title="Profile" back-link="Back">
      <f7-nav-right>
        <f7-link  href="/" class="menu-icon"><i class="az-icon-home-house-interface-ui-website"></i></f7-link>
      </f7-nav-right>
    </f7-navbar>


      <f7-row>
        <div class="col-40 col-sm-0">
          <div class="left-az-logo">
            <img src="../assets/images/left-logo.png" alt="" />
          </div>
        </div>
        <div class="col-60 col-sm-100">
              <!-- Profile Content -->
    <div class="npage-content">
      <!-- <h3 class="text-center">Dr.Zenca</h3> -->
      <div style="color: red" v-if="errors">
        <p v-for="(v, k) in errors" :key="k">{{ v[0] }}</p>
      </div>
      <f7-list inline-labels no-hairlines-md>
        <f7-list-input 
          type="text"
          label="Full Name"
          :value="user.name" 
          @input="user.name = $event.target.value">
        </f7-list-input>
        <f7-list-input 
          type="text" 
          label="Email Address" 
          :value="user.email" 
          @input="user.email = $event.target.value">
        </f7-list-input>
        <f7-list-input 
          type="text" 
          label="Username" 
          :value="user.username" 
          @input="user.username = $event.target.value">
        </f7-list-input>
        <f7-list-input 
          type="password" 
          label="Password" 
          :value="user.password" 
          @input="user.password = $event.target.value">
        </f7-list-input>
        <!-- <f7-list-input 
          type="text" 
          label="Mobile" 
          :value="user.phone_number" 
          @input="user.phone_number = $event.target.value">
        </f7-list-input> -->
        <!-- Specialist -->
        <f7-list-input
          label="Speciality"
          type="select"
          :value="user.speciality_id"
          :defaultValue="user.speciality_id"
          @input="user.speciality_id = $event.target.value"
        >
          <option value="">-- Select Speciality --</option>
          <option v-for="spc in specialities" :key="spc.id" :value="spc.id">{{ spc.name }}</option>
        </f7-list-input>
        <f7-list-input 
          label="Country"
          outline
          type="select"
          :value="country_id" 
          @input="country_id = $event.target.value"
        >
          <option value="">-- Select Country --</option>
          <option v-for="country in countries" :key="country.id" :value="country.id">{{ country.name }}</option>
        </f7-list-input>
        <f7-list-input 
          label="Area"
          type="select"
          :value="user.area_id"
          :defaultValue="user.area_id"
          @input="user.area_id = $event.target.value">
          <option value="">-- Select Area --</option>
          <option v-for="are in filtered_areas" :key="are.id" :value="are.id" :selected="are.id == user.area_id">{{ are.name }}</option>
        </f7-list-input>
        <li data-v-16c1c055="" class="">
          <div class="item-content item-input item-input-with-value">
            <div class="item-inner">
              <div class="item-title item-label">Mobile</div>
              <div class="item-input-wrap">
                <select name="" v-model="country_code" style="width: 18%; display: inline-block;">
                  <option value="">--</option>
                  <option v-for="country in countries" :key="country.id" :value="country.id">{{ country.country_code }}</option>
                </select>
                <input type="number" class="input-with-value" style="width: 75%; display: inline-block;" data-kpxc-id="kpxcpw342845667" v-model="user.phone_number">
              </div>
            </div>
          </div>
        </li>
      </f7-list>
        <!-- <qrcode-vue v-if="user.user_type == 'default_user'" :value="value.user_id" :size="size" level="H" /> -->
        <br>
       <div class="registration-button">
        <f7-row>
          <f7-col width="15"></f7-col>
          <f7-button class="col-70 yellowBg" round fill @click="updateProfile">Update Profile</f7-button>
          <f7-col width="15"></f7-col>
        </f7-row>
        <!-- <f7-row>
          <f7-col width="15"></f7-col>
          <f7-button class="col-70" round href="/login/" color="white">Back to Login</f7-button>
          <f7-col width="15"></f7-col>
        </f7-row> -->
      </div>
      </f7-list>
    </div>

        </div>
      </f7-row>


    <!-- Event Header -->
    <!-- <div class="profile-banner BG"> -->
      <!-- <h2>Profile</h2> -->



    <!-- </div> -->

  </f7-page>
</template>
<script>
    import QrcodeVue from 'qrcode.vue'

export default {
  data() {
    return {
       value: { 
         type: String, 
         user_id: '0'
       }, 
      size: 300,
      user: {
        id: '',
        name: '',
        username: '',
        email: '',
        password: '',
        phone_number: '',
        area_id: '',
        speciality_id: ''
      },
      countries: [],
      areas: [],
      specialities: [],
      errors: [],
      filtered_areas: [],
      country_id: '',
      country_code: ''
    }
  },
   components: {
      QrcodeVue,
  },
  methods: {
    updateProfile: function() {
      this.errors = []
      for( let prob in this.user ) {
        if( prob != 'id' && prob != 'password' ) {
          if( this.user[prob] == '') {
            this.$f7.dialog.alert('Sorry, but must fill all fields', 'Missing data!!')
            return false
          }
        }
      }

      this.$f7.preloader.show()

      this.$http.post( this.$root.apiBaseURL + 'update-profile', this.user)
        .then( (res) => {
          this.$f7.dialog.alert(res.data.message, 'Success')
          this.$f7.preloader.hide()
          localStorage.setItem('loggedUser', JSON.stringify(this.user))
        })
        .catch( (error) => {
          this.$f7.preloader.hide()
          this.errors = error.response.data.errors
          this.$f7.dialog.alert('Please check these errors', 'Error', () => {
            this.scrollTop()
          })

        })
    },
    scrollTop: function() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  },
  watch: {
    country_id: function(new_id) {
      this.country_code = new_id
      this.filtered_areas = this.areas.filter( (area) =>  {
        return area.country_id == new_id
      })
    }
  },
  mounted: function() {

    this.user = JSON.parse(localStorage.getItem('loggedUser'))
    this.value.user_id = String(this.user.id);

    this.$http.get( this.$root.apiBaseURL + 'get-specialities' )
      .then( (res) => {
        this.specialities = res.data.specialities
      })
      .catch( (error) => {
        console.log(error)
      })

    this.$http.get( this.$root.apiBaseURL + 'get-countries' )
      .then( (res) => {
        this.countries = res.data.countries
      })
      .catch( (error) => {
        console.log(error)
      })

    this.$http.get( this.$root.apiBaseURL + 'get-areas' )
      .then( (res) => {
        this.areas = res.data.areas
      })
      .catch( (error) => {
        console.log(error)
      })

    var _this = this
    this.$http.get( this.$root.apiBaseURL + 'get-area-country/' + this.user.area_id )
      .then( (response) => {
          this.country_id = response.data.country_id
          this.country_code = response.data.country_id
          setTimeout(function(){
              _this.filtered_areas = _this.areas.filter( (area) =>  {
                  return area.country_id == _this.country_id
              })
          }, 1000)
          
      } )
      .catch( (error) => {
          console.log(error)
      })
  }
}
</script>
<style scoped>
  .menu-icon i::before {
    color: #870047;
    font-size: 35px;
  }
</style>
